import { MouseEvent } from 'react';

import { isModifiedClick } from './clickTracking';
import { trackMainHeroCtaClick } from './trackMainHeroEvents';

/** Info card link is the third fixed CTA slot, after cta_1 (0) and cta_2 (1). */
export const INFO_CARD_CTA_SLOT = 2;

export interface HeroCtaTracking {
  /** Hero variant reported as `type`; the tracker defaults it to CIP hero. */
  type?: string;
  coOpBrand: string | null;
}

/**
 * `onClick`/`onAuxClick` props for a hero CTA that report `click_hero_cta`.
 * A plain click holds navigation until GTM dispatches the hit; modified and
 * middle clicks open a new tab, so they are tracked without deferring.
 */
export const heroCtaHandlers = (
  { type, coOpBrand }: HeroCtaTracking,
  href: string,
  linkText: string,
  index: number
) => {
  const clickData = () => ({
    interactionLocation: window.location.pathname,
    linkUrl: href,
    linkText,
    index,
    type,
    coOpBrand,
  });

  return {
    onClick: (event: MouseEvent<HTMLAnchorElement>) => {
      if (isModifiedClick(event)) {
        trackMainHeroCtaClick({ data: clickData() });
        return;
      }

      event.preventDefault();
      trackMainHeroCtaClick({
        data: clickData(),
        eventCallback: () => {
          window.location.href = href;
        },
      });
    },
    // Middle clicks fire `auxclick`, not `click`, and open a new tab.
    onAuxClick: (event: MouseEvent<HTMLAnchorElement>) => {
      if (event.button !== 1) return;
      trackMainHeroCtaClick({ data: clickData() });
    },
  };
};
